import { Typography } from "@mui/material";
import i18n from "../../i18n";

export const AgreementStatusText = (props) => {
    const { status_name, status_name_eng, status_key } = props.status;
    const statusText = i18n.language === "pl" ? status_name : status_name_eng;

    const colors = {
        Active: "#068e06",
        Completed: "#0B94D8",
        Cancelled: "#D80B0B",
        agreementCancelled: "#D80B0B",
        RemovedFromAgreement: "#D80B0B",
        None: "#585858ff",
        Transformed: "#516e00ff",
        Signed: "#009c00ff",
        underPreparation: "#ffbb00ff",
    };

    if (!(status_key in colors)) {
        return <Typography>{statusText}</Typography>;
    }

    return <Typography color={colors[status_key]}>{statusText}</Typography>;
};
